// function with the name whToKwh
// that takes a number as an argument
// and it changes the number to kWh
// with 0 decimal places
// and returns a number

export const whToKwh = (number: number): number => {
  return Number((number / 1000).toFixed(0));
};
